"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarControlsWithGroup = void 0;
const SplitButton_1 = require("./SplitButton/SplitButton");
const types_1 = require("../types");
exports.ToolbarControlsWithGroup = {
    [types_1.TOOLBAR_GROUP_TYPE.splitButton]: SplitButton_1.SplitButton
};
//# sourceMappingURL=ToolbarControlsWithGroup.js.map